angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    .state 'app.weclome',
      url: '/weclome'
      templateUrl: 'apps/weclome/weclome'
      controller: 'WeclomeCtrl'
